module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "mps-actions"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$root.request.car_id),
      expression: "$root.request.car_id"
    }],
    attrs: {
      "id": "regnr",
      "type": "text",
      "name": "regnr",
      "placeholder": "AB12345 eller ABC123"
    },
    domProps: {
      "value": (_vm.$root.request.car_id)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.$root.toDamages(true)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$root.request, "car_id", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "disabled": _vm.$root.ui.loading,
      "id": "gtm-inquiry-continue-license"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$root.toDamages(true)
      }
    }
  }, [_vm._v("Fortsett")])]), _vm._v(" "), _c('a', {
    staticClass: "skip-license",
    attrs: {
      "href": "#",
      "id": "gtm-inquiry-skip-license"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$root.toDamages(false)
      }
    }
  }, [_vm._v("Fortsett uten reg.nr")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49d774b1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./requests/assets/src/components/Opq/tags/StartActions.vue
// module id = 112
// module chunks = 0